import { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCALE } from '../../site-config';
import { EmailBounceBanner } from './EmailBounceBanner';

const SUPPORTED_LOCALES = ['en', 'es'];

export const LocaleLayout: React.FC = () => {
  const { locale } = useParams<{ locale: string }>();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (locale && SUPPORTED_LOCALES.includes(locale) && i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  if (!locale || !SUPPORTED_LOCALES.includes(locale)) {
    return <Navigate to={`/${DEFAULT_LOCALE}`} replace />;
  }

  // Mounted here so a user whose address bounced sees the correction path on
  // whatever page they land on -- they are signed in (login is not gated on
  // email_verified) and would otherwise have no signal that anything failed.
  // Renders null unless email_status is 'bounced' or 'complained', so it is
  // inert for signed-out visitors and healthy accounts alike.
  return (
    <>
      <EmailBounceBanner />
      <Outlet />
    </>
  );
};
